module.exports = __webpack_public_path__ + "img/mail-sent.03db79b4.svg";